import { toBoolean } from '../../Utility';

export function zMarshalToBoolean(val: unknown): boolean {
    return toBoolean(val, false);
}
